import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Valentina R.',
  service: 'Esculturas de uñas',
  text: 'La atención de Cande es increíble. Mis uñas duran intactas casi un mes y el diseño siempre supera mis expectativas. El estudio es hermoso y súper relajante.'
}, {
  name: 'Sofía M.',
  service: 'Laciado Orgánico',
  text: 'Me hice el laciado y mi pelo cambió por completo. Cero frizz, súper brillante y suave. Además me explicó todo el proceso y cómo cuidarlo en casa.'
}, {
  name: 'Camila G.',
  service: 'Kapping',
  text: 'Desde que me hago kapping acá mis uñas naturales crecieron un montón y no se quiebran. Los productos que usan son de primera calidad.'
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-rose/10" data-id="element-195">
      <div className="container mx-auto px-6 md:px-12" data-id="element-196">
        <div className="text-center mb-16" data-id="element-197">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-brand-mocha mb-4" data-id="element-198">
            Lo que dicen nuestras clientas
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} className="h-[1px] bg-brand-gold mx-auto" data-id="element-199" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-200">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-rose/20 relative" data-id="element-201">
              <div className="flex gap-1 mb-4 text-brand-gold" data-id="element-202">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-203" />)}
              </div>
              <p className="text-brand-mocha/80 text-sm leading-relaxed mb-6 italic" data-id="element-204">
                "{testimonial.text}"
              </p>
              <div className="mt-auto" data-id="element-205">
                <h4 className="font-serif text-brand-mocha font-medium" data-id="element-206">
                  {testimonial.name}
                </h4>
                <p className="text-xs text-brand-mocha/50 uppercase tracking-wider mt-1" data-id="element-207">
                  {testimonial.service}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}